import SurveysComponent from '../../components/SurveySeries/SurveySeries';

function Surveys() {
  return <SurveysComponent />;
}

export default Surveys;
